<template>
    <div class="monopoly-board">
    <div class="card-holder"></div>
    <div class="roads-wrapper">

        <div class="row">
            <div>
                <div class="corner start">
                <span>Go</span>
                </div>

                <ul>
                <li class="road brown">
                    <div class="road-name">Sirdar <br/>Road</div>
                    <div class="price">60</div>
                </li>

                <li class="chance like">
                    <div class="chance-name">Like <br/>my page</div>
                    <div class="picto"></div>
                </li>

                <li class="road brown">
                    <div class="road-name">Bramford <br/>Road</div>
                    <div class="price">80</div>
                </li>

                <li class="station">
                    <div class="road-name">Westerfield <br/>Station</div>
                    <div class="price">200</div>
                </li>

                <li class="road light-blue">
                    <div class="road-name">Wherestead <br/>Road</div>
                    <div class="price">100</div>
                </li>

                <li class="road light-blue">
                    <div class="road-name">Cambridge <br/>Drive</div>
                    <div class="price">120</div>
                </li>
                </ul>
            </div>
        </div>

        <div class="row">
            <div>
                <div class="corner bugs">
                <span>TAX <small>You're stuck for one turn</small></span>
                </div>

                <ul>
                <li class="road purple">
                    <div class="road-name">Upper Brook <br/>Street</div>
                    <div class="price">140</div>
                </li>

                <li class="road purple">
                    <div class="road-name">Nacton <br/>Road</div>
                    <div class="price">140</div>
                </li>

                <li class="station">
                    <div class="road-name">Felixstowe <br/>Station</div>
                    <div class="price">200</div>
                </li>

                <li class="road orange">
                    <div class="road-name">Colchester <br/>Road</div>
                    <div class="price">160</div>
                </li>

                <li class="chance pinned">
                    <div class="chance-name">Networking<br/> Event</div>
                    <div class="picto"></div>
                </li>

                <li class="road orange">
                    <div class="road-name">Fore <br/>Street</div>
                    <div class="price">180</div>
                </li>
                </ul>
            </div>
        </div>

        <div class="row">
            <div>
                <div class="corner coffee">
                <span>Coffee break</span>
                </div>

                <ul>
                <li class="road red">
                    <div class="road-name">Museum <br/>Street</div>
                    <div class="price">200</div>
                </li>

                <li class="chance fork">
                    <div class="chance-name">Register <br/>Interest</div>
                    <div class="picto"></div>
                </li>

                <li class="road red">
                    <div class="road-name">Woodbridge <br/>Road</div>
                    <div class="price">220</div>
                </li>

                <li class="station">
                    <div class="road-name">Ipswich<br/> Station</div>
                    <div class="price">200</div>
                </li>

                <li class="road yellow">
                    <div class="road-name">Spring <br/> Road</div>
                    <div class="price">280</div>
                </li>        

                <li class="road yellow">
                    <div class="road-name">Foxhall <br/>Road</div>
                    <div class="price">360</div>
                </li>
                </ul>
            </div>
        </div>

        <div class="row">
            <div>
                <div class="corner error">
                <span>Remortgage <small>wait for a turn</small></span>
                </div>

                <ul>
                <li class="road green">
                    <div class="road-name">Belstead <br/>Road</div>
                    <div class="price">460</div>
                </li>

                <li class="road green">
                    <div class="road-name">Parliment <br/>Road</div>
                    <div class="price">540</div>
                </li>

                <li class="chance follow">
                    <div class="chance-name">Follow<br/> me</div>
                    <div class="picto"></div>
                </li>

                <li class="station">
                    <div class="road-name">Derby <br/>Station</div>
                    <div class="price">200</div>
                </li>

                <li class="road blue">
                    <div class="road-name">Henley<br/> Road</div>
                    <div class="price">600</div>
                </li>

                <li class="road blue">
                    <div class="road-name">Bucklesham <br>Road</div>
                    <div class="price">650</div>
                </li>
                </ul>
            </div>
        </div>
    </div>
    </div>
</template>


<script>

import $ from 'jquery'


export default {
  name: 'monopoly',
  mounted() {
    console.log("MOUNTED MONOPOLY COMPONENT");
  }
}
</script>


<style lang="scss">

$brown: #784d3c;
$light-blue: #badbee;
$purple: #aa3b80;
$orange: #d58a37;
$red: #cd0722;
$yellow: #fff139;
$green: #5fa55d;
$blue: #2c67a1;
$gray: #1e1f26;
$black:#201e21;
$board-color: #d2e2c7;

body{
  perspective:1050px;
  perspective-origin: 50% 100px;
}

.monopoly-board{
  width: 100%;
  max-width: 1000px; 
  margin: 20px auto;
  position:relative;
  padding: 0;

  .roads-wrapper{
    position:absolute;
    top:0;
    left:0;
    width:100%;
    padding-bottom:100%;
    height:0;
    background-color:$board-color;
    transform: rotateX(75deg) rotateZ(0deg);
    animation:rotate linear 25s;
    animation-iteration-count: infinite;
    border-radius:10px;
    overflow:hidden;

    &:before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: -1;
      transform: translate(-500px) rotate(45deg);
      background-image: url('../assets/Spinning_House_Logo_Property.jpg');
      background-size:20%;
      background-repeat:no-repeat;
      background-position:center;
    }

    .row{
      position: absolute;
      width: 84.5%;


      > div{
        display: flex;
        flex-direction: row-reverse;
        flex-wrap: wrap;
        width:100%;
        border-top: 3px solid #201e21;

        .corner {
          width: 18%;
          padding-bottom: 18%;
          height: 0;
          align-items: center;
          justify-content: center;
          position:relative;

          & > span {
            position: absolute;
            text-transform: uppercase;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%) rotate(-45deg);

            font-weight: 900;
            font-family: sans-serif;
            letter-spacing: 1px;
            align-items: center;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;

            small{
              font-size: 10px;
              display: block;
              font-weight: 100;
              text-transform: initial;
              text-align: center;
            }
          }

          &.start > span{
            font-size: 40px;
            &:after {
              content: '\f30a';
              font-family: "Font Awesome 5 Pro";
              display: block;
              font-size: 50px;
              color: $red;
              font-weight: 500;
              line-height: 21px;
            }
          }

          &.bugs > span{
            font-size:25px;
            &:before {
              content: '\f188';
              font-family: "Font Awesome 5 Pro";
              display: block;
              font-size: 30px;
              color: $red;
              font-weight: bold;
              line-height: 35px;
            }
          }

          &.coffee > span {
            font-size:15px;
            text-align:center;
            &:before{
              content:'\f7b7';
              font-family: "Font Awesome 5 Pro";
              display: block;
              font-size: 25px;
              color: $brown;
              font-weight: bold;
              line-height: 35px;
            }
          }

          &.error > span{
            text-align:center;

          }
        }

        > ul{
          list-style: none;
          display: flex;
          flex-direction: row-reverse;
          padding: 0;
          margin: 0;
          width: calc(82% - 3px );
          border-right: 3px solid #201e21;

          li {
            width: 100%;
            border-left: 3px solid $black;
            display:flex;
            flex-direction:column;
            flex-wrap: wrap;
            justify-content: space-between;
            position:relative;

            &:last-child{
              border-left:0;
            }

            &.chance{
              justify-content: flex-start;

              .chance-name{
                font-size:10px;
                padding-top:15%;
                text-align:center;
                text-transform:uppercase;
              }

              .picto{
                text-align:center;
                padding-top:15px;
                &:before{
                  font-family:"Font Awesome 5 Pro";
                  color:$black;
                  font-size:35px;
                }
              }

              &.like{
                .picto:before{
                  content:'\f004';
                }
              }

              &.pinned{
                .picto:before{
                  content:'\f08d';
                }
              }

              &.follow{
                .picto:before{
                  content:'\f8ea';
                  font-weight:bold;
                }
              }
              &.fork{
                .picto:before{
                  content:'\f126';
                }
              }
            }

            &.station{
              text-align:center;
              text-transform:uppercase;

              .road-name{
                justify-content:center;
                font-size:10px;
                padding-top:15%;

                &:after{
                  content:'\f239';
                  font-family:"Font Awesome 5 Pro";
                  display:block;
                  font-size:35px;
                  padding-top:10px;
                }
              }
            }

            &.road{
              text-align:center;
              text-transform:uppercase;

              &:before{
                content:'';
                height:20%;
                width:100%;
                display:block;
                border-bottom:3px solid $black;
                position:absolute;
                top:0;
                left:0;
              }

              .road-name{
                display:flex;
                padding-top:50%;
                justify-content:center;
                font-size:10px;
              }

              &.brown{
                &:before{
                  background:$brown;
                }
              }

              &.light-blue{
                &:before{
                  background:$light-blue;
                }
              }
              &.purple{
                &:before{
                  background:$purple;
                }
              }
              &.orange{
                &:before{
                  background:$orange;
                }
              }

              &.red{
                &:before{
                  background:$red;
                }
              }

              &.yellow{
                &:before{
                  background:$yellow;
                }
              }

              &.green{
                &:before{
                  background:$green;
                }
              }

              &.blue{
                &:before{
                  background:$blue;
                }
              }
            }

            .price{
              display:flex;
              justify-content:center;
              font-size:10px;
              padding-bottom:10px;
              &:before{
                content:'£';
                font-family:"Font Awesome 5 Brands";
                margin-right:5px;
              }
            }
          }
        }
      }

      &:nth-child(1){
        bottom:0;
        right:0;
      }

      &:nth-child(2){
        top: 100%;
        right: 84.5%;
        transform: rotate(90deg);
        transform-origin: 100% 0%;
      }

      &:nth-child(3){
        top: 15.5%;
        right: 100%;
        transform: rotate(180deg);
        transform-origin: 100% 0;
      }

      &:nth-child(4){
        top: 0;
        left: 0;
        transform: rotate(270deg);
        transform-origin: 100% 0;
      }
    }
  }
}

@keyframes rotate {
    
  from{
    transform: rotateX(75deg) rotateZ(45deg);
  }

  50%{
    transform: rotateX(80deg) rotateZ(-202deg);
  }

  to{
    /* transform: rotateX(75deg) rotateZ(-405deg); */
    transform: rotateX(75deg) rotateZ(45deg);
  }
  
}

</style>